import global from "global";
import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import savedItemsSdkProvider from "../../providers/savedItemsSdkProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { ServiceError, SdkError } from "../errors";
import isServiceError from "./isServiceError";
import isAxiosTimeout from "./isAxiosTimeout";
import { GET_SAVED_ITEMS_REQUEST_TIMEOUT } from "../../state/modules/savedItems/constants";
import inFlightCancellationFacade from "./inFlightCancellationFacade";

const { cancelTokenExecutor, makeRequest } = inFlightCancellationFacade();

const getSavedItems =
  ({ offset, limit, sort, sortOrder, cancelInFlight }) =>
  async () => {
    const {
      expands: { EXPAND_VARIANTS: expand },
      isRequestCancelled
    } = savedItemsSdkProvider();
    const sdkInstance = await sdkInstanceProvider("savedItems");
    const { getSavedItemsRequestTimeout } = clientConfigurationProvider();

    let timeout;

    try {
      const { data } = await makeRequest({
        cancelInFlight,
        request: () =>
          sdkInstance.getItems({
            offset,
            expand,
            limit,
            sort,
            sortOrder,
            requestOptions: {
              timeout: getSavedItemsRequestTimeout,
              cancelTokenExecutor
            }
          })
      });

      return data;
    } catch (e) {
      if (isRequestCancelled(e)) {
        return null;
      }
      if (isServiceError(e)) {
        throw new ServiceError(e);
      }
      if (isAxiosTimeout(e)) {
        throw new ServiceError(new Error(GET_SAVED_ITEMS_REQUEST_TIMEOUT));
      }
      throw new SdkError(e);
    } finally {
      global.clearTimeout(timeout);
    }
  };

export default getSavedItems;
